import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserProfile } from './UserProfile';

const RevalidationWrapper = ({ children }) => {
  const { profile, loading } = useUserProfile();

  if (loading) {
    return <div>Loading...</div>;
  }

  // Check if the user has revalidation access — adjust this condition to fit your schema
  const hasAccess = profile?.revalidation_membership === true;

  if (!hasAccess) {
    return <Navigate to="/dashboard/signup" replace />;
  }

  return children;
};

export default RevalidationWrapper;
